import { localeToIntlCode, type Locale } from "lib/i18n/config";
import { interpolateTemplate } from "lib/i18n/dictionary";
import type { PluralForms } from "lib/i18n/types";

// The phrase for `count` in the locale's plural category, with {count} filled in.
export function formatPlural(locale: Locale, forms: PluralForms, count: number) {
  const category = new Intl.PluralRules(localeToIntlCode[locale]).select(count);
  const template = category in forms ? forms[category as keyof PluralForms] : forms.other;
  return interpolateTemplate(template, { count: String(count) });
}
